<template>
	<div>
		<div class="lianxi">
			<el-row>
				<el-col :xs="24" :sm="24">
					<div style="display: flex;">
						<div><img id="header-img" src="http://dgoss.91dageng.com.cn/png/ZO93CVAiIyxInJAM3322_组 39@3x.png" /></div>
						<div class="lianxi_title">联系我们</div>
						<div><img id="header-img" src="http://dgoss.91dageng.com.cn/png/kFL0fYbyuvLYSb8G2012_组 40@3x.png" /></div>
					</div>
				</el-col>
			</el-row>
		</div>

		<!-- 盒子 -->
		<div class="border_parent">
			<el-row :gutter="10">
				<el-col :xs="24" :sm="24">
					<div class="border">
						<div class="lianxi_title1" style="margin-left: 10px; margin-bottom: 20px;font-size: 1.125em;
	font-weight: bold;">大庚信息科技(上海)有限公司</div>
						<div class="grid-content bg-purple" style="display: flex;flex-direction: row; align-items: center;">
							<div><img id="header-img" src="http://dgoss.91dageng.com.cn/png/Bv2N274Ctm550Tuo3123_组 46@3x.png" /></div>
							<div style="color: #666666;">地址:上海普陀区祁连山南路2891弄科技楼105号213～214室</div>
						</div>
						<div class="grid-content bg-purple" style="display: flex;flex-direction: row; align-items: center;">
							<div><img id="header-img" src="http://dgoss.91dageng.com.cn/png/zIwcIo4NRzjWyUdO2021_组 47@3x.png" /></div>
							<div style="color: #666666;">客服热线: 400-655-0669</div>
						</div>
						<div class="grid-content bg-purple" style="display: flex;flex-direction: row; align-items: center;">
							<div><img id="header-img" src="http://dgoss.91dageng.com.cn/png/pzoZIkbivTfVghEe0033_组 48@3x.png" /></div>
							<div style="color: #666666;">联系邮箱: data@wx.dagengdata.cn</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<div style="width: 90%;margin: 0 auto;"><img style="width: 100%;height: 100%;" src="http://dgoss.91dageng.com.cn/png/VvPN59vbdSH1Aa820102_组 50@3x.png" /></div>
	<!-- 	留言板
		<div class="lianxi">
			<el-row>
				<el-col :span="24">
					<div style="display: flex;">
						<div><img id="header-img" src="http://dgoss.91dageng.com.cn/png/ZO93CVAiIyxInJAM3322_组 39@3x.png" /></div>
						<div class="lianxi_title">留言板</div>
						<div><img id="header-img" src="http://dgoss.91dageng.com.cn/png/kFL0fYbyuvLYSb8G2012_组 40@3x.png" /></div>
					</div>
				</el-col>
			</el-row>
		</div>
		表单
		<div style="width: 90%;margin: 0 auto;">
			<el-row>
				<el-col :span="24">
					<div style="display: flex;justify-content: space-between;">
						<div class="grid-content bg-purple">
							<div>您的姓名</div>
							<div style="display: flex;align-items: center;margin-top: 20px;">
								<el-input v-model="input" placeholder="请输入您的姓名"></el-input>
								<span style="color: red;font-size: 28px;padding-left: 10px;">*</span>
							</div>
						</div>
						<div class="grid-content bg-purple">
							<div>您的邮箱</div>
							<div style="display: flex;align-items: center;margin-top: 20px;">
								<el-input v-model="input" placeholder="请输入您的邮箱"></el-input>
								<span style="color: red;font-size: 28px;padding-left: 10px;">*</span>
							</div>
						</div>
						<div class="grid-content bg-purple">
							<div>您的电话</div>
							<div style="display: flex;align-items: center;margin-top: 20px;">
								<el-input v-model="input" placeholder="请输入您的电话"></el-input>
								<span style="color: red;font-size: 28px;padding-left: 10px;">*</span>
							</div>
						</div>
					</div>
					<div class="grid-content bg-purple">
						<div>留言内容</div>
						<div style="display: flex;align-items: center;margin-top: 20px;">
							<el-input type="textarea" :autosize="{ minRows: 6, maxRows: 6 }" placeholder="请输入您想要留言的内容" v-model="textarea2"></el-input>
							<span style="color: red;font-size: 28px;padding-left: 10px;">*</span>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		提交
		<div class="lianxi">
			<el-row>
				<el-col :span="24">
					<div style="display: flex;">
						<div><el-button type="primary" round>提交</el-button></div>
					</div>
				</el-col>
			</el-row>
		</div> -->
	</div>
</template>

<script>
    export default {
        name: 'Index',
        data() {
            return {
                carousel_height: '550px',
            }
        },
        methods: {},
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }

        },
    }
</script>

<style>
.lianxi {
	width: 100%;
	display: flex;
	justify-content: center;
	margin: 20px 0;
}
.lianxi_title {
	font-family: 'PingFang SC';
	margin-top: 10px;
	font-size: 1.125em;
	font-weight: bold;
	text-align: center;
}
#header-img {
	width: 50px;
	height: 50px;
	float: left;
	margin: auto;
}
.border_parent {
	width: 90%;
	margin: 50px auto;
}
/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
	.slider_img {
		height: 250px;
		width: 100%;
	}

	.border_parent {
		display: flex;
		width: 90%;
		margin: auto;
		height: auto;
		flex-direction: column;
	}

	.border {
		border-radius: 6px;
		/* border: 1px solid #EBEEF5; */
		float: left;
		width: 100%;
		height: auto;
		margin: 10px 0 auto;
		/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) */
		/*background: aquamarine;*/
	}

	.border_img_parent {
		margin-top: 0;
	}

	.product_mobile {
		width: 90%;
		align-items: center;
		margin: 20px auto;
		height: auto;
		background: #f2f6fc;
	}

	.product_mobile_content {
		width: 100%;
		margin-top: 15px;
	}

	.product_mobile_content_one {
		margin-top: 5px;
	}

	.product_mobile_content_two {
		margin-top: 5px;
	}

	.product_mobile_img_div {
		display: flex;
		width: 100%;
		height: auto;
		justify-content: center;
		margin-top: 10px;
		margin-bottom: 15px;
	}

	.product_mobile_img {
		float: left;
	}

	.product_mobile_title {
		font-weight: bold;
	}

	.product_pc_one {
		width: 100%;
		margin-top: 15px;
	}

	.font_size_30 {
		font-size: 1.25em;
	}

	.product_font_style {
		font-size: 1em;
	}

	.product_pc_img {
		height: 280px;
		width: 320px;
	}

	.product_pc_img_div {
		width: 100%;
		float: left;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 15px;
	}

	.product_pc {
		display: flex;
		width: 90%;
		height: auto;
		margin: 20px auto;
		background: #f2f6fc;
		flex-direction: column;
	}

	.head-label {
		display: flex;
		margin-top: 10px;
	}

	.product_spec_parent {
		display: flex;
		width: 90%;
		align-items: center;
		justify-content: center;
		margin: 20px auto;
		height: auto;
		flex-direction: column;
	}

	.border_spec {
		float: left;
		height: auto;
		margin: 8px;
		width: 100%;
		border-radius: 6px;
		border: 1px solid #ebeef5;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.border_title {
		font-family: 'PingFang SC';
		margin-top: 5px;
		font-size: 1.125em;
		font-weight: bold;
	}

	.border_content_one {
		margin-top: 5px;
		color: #999999;
		/* font-size: 1.125em; */
	}

	.border_content_two {
		margin-top: 5px;
		font-size: 1.125em;
		margin-bottom: 8px;
		color: #0775ff;
		display: flex;
		justify-content: center;
	}

	.img_border {
		margin-top: 8px;
		width: 80px;
		height: 80px;
	}

	.border_spec_inner_one {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 8px;
		/*background-color: aqua;*/
		height: 70px;
	}

	.border_spec_content_one {
		margin-top: 5px;
		font-size: 1.125em;
		float: left;
	}

	.border_spec_inner_last {
		/*background-color: bisque;*/
		margin-top: 5px;
		font-size: 1.125em;
		float: left;
		margin-bottom: 8px;
	}

	.about_me {
		display: flex;
		margin-top: 10px;
		width: 100%;
	}
}
</style>
